export class GridConstants {
  // Checkbox column definition
  static checkbox = {
    headerName: '',
    colId: 'checkBoxId',
    field: '',
    minWidth: 50,
    maxWidth: 50,
    suppressSizeToFit: true,
    sortable: false,
    precedence: -99999,
    suppressHeaderMenuButton: true,
    checkboxSelection: true,
    headerCheckboxSelection: true,
    suppressRowClickSelection: true,
    filter: false,
  };

  // Start and End Date column definitions
  static startEndDateColDefs = [
    { field: 'startDate', headerName: 'Start Date (MM/DD/YYYY)', cellRendererCode: 'DATE', width: 125 },
    { field: 'endDate', headerName: 'End Date (MM/DD/YYYY)', cellRendererCode: 'DATE', width: 125 },
  ];

  // // Main Audit column definitions
  // auditColDefs: [
  //   { field: 'status', headerName: 'Status', cellRendererCode: 'ENUM', enumType: 'ENTITY_STATUS', width: 125, isAudit: true },
  //   { field: 'valStatus', headerName: 'Validation', cellRendererCode: 'ENUM', enumType: 'VAL_STATUS', width: 125, isAudit: true },
  //   { field: 'recBy', headerName: 'Recorded By', cellRendererCode: 'REC_BY', width: 125, isAudit: true },
  //   { field: 'verStartInstant', headerName: 'Version Start Instant', cellRendererCode: 'INSTANT', width: 125, isAudit: true },
  //   { field: 'verEndInstant', headerName: 'Version End Instant', cellRendererCode: 'INSTANT', width: 125, isAudit: true },
  //   { field: 'version', headerName: 'Version', cellRendererCode: 'STRING', width: 125, isAudit: true },
  //   { field: 'srcSys', headerName: 'Source System', cellRendererCode: 'ENUM', enumType: 'SRC_SYS', width: 125, isAudit: true },
  // ],

  // Search results column definition
  static searchColDef = {
    field: 'searchResultInfo',
    headerName: 'Search Results',
    minWidth: 750,
    rowGroup: true,
    hide: true, // Hidden because the grouping will use the autoGroupColumn
  };

  // Auto group column definition
  static autoGroupColDef = {
    headerName: 'Search Results',
    minWidth: 750,
    cellRendererParams: {
      suppressCount: true, // Hides the count of grouped items
      innerRenderer: (params) => params.value, // Renders group values
    },
  };

  // Audit column definitions that are typically hidden
  static removeAuditFieldDefs = (fieldToFieldDef) => {
    const auditFields = ['id', 'entity', 'entityId', 'rsrcCode', 'valStatus', 'sor', 'ref'];
    auditFields.forEach((auditfield) => {
      delete fieldToFieldDef[auditfield];
    });
  };
}

// Empty context menu item to indicate no available options.
export const EMPTY_CONTEXT_MENU_ITEM = {
  name: 'No options available',
  disabled: true,
};
